export const filterDateTime = state => {
  return state.filterDateTimeRange;
};

export const filterDate = state => {
  return state.filterDates;
};

export const filterTime = state => {
  return state.filterTimes;
};

export const filterButtonLoading = state => {
  return state.filterButtonLoading;
};

export const toastTimeout = state => {
  return state.toastTimeout;
};

export const heatmapVisible = state => {
  return state.heatmapVisible;
};

export const getMapBounds = state => {
  return {
    latStart: state.mapBounds.getSouthEast().lat,
    lngStart: state.mapBounds.getNorthWest().lng,
    latStop: state.mapBounds.getNorthWest().lat,
    lngStop: state.mapBounds.getSouthEast().lng
  };
};

export const calculateBins = state => {
  const dLng = Math.abs(
    state.mapBounds.getNorthWest().lng - state.mapBounds.getSouthEast().lng
  );
  return dLng / 20;
};

export const visiblePoints = state => {
  return state.points.slice(0, state.heatmapVisiblePoints);
};

export const mapCenter = state => {
  return state.mapCenter;
};

export const markers = state => {
  return state.markers;
};

export const currentMarkerID = state => {
  return state.currentMarkerID;
};

export const reviewDialog = state => {
  return state.reviewDialog;
};

export const budget = state => {
  return state.budget;
};

export const startTime = state => {
  return state.filterDates.start;
};

export const stopTime = state => {
  return state.filterDates.stop;
};
